import { environment } from './../../../../environment/environment';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { AuthService } from '../../../core/services/auth-service/auth.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import {
  invalidMailPassword,
  noAccountMail,
  serverError,
  welcomeMessage,
  notVerifiedEmail,
  codeSended,
  invalidMail,
  loginExceedsSessionsNumber,
} from '@core/models/messages';
import { CLogin } from '@core/models/login';
import { patternEmail, patternPassword } from '@core/models/pattern';
import { StripeService } from '@core/services/stripeService/stripe-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';
@Component({
  selector: 'app-loginpage',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
})
export class LoginpageComponent implements OnInit {
  /* boolean */
  loadSpinner: boolean = false;
  showPassword: string = 'password';
  show_button_resend: boolean = false;
  messagecompany: boolean = true;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  invalidCredentials: string = '';
  noUserAccount: string = '';
  validEmaill: string = '';
  company_id: any;
  type: any;
  /* formGroup */

  emailControl = new FormControl();
  generateLoginForm: FormGroup = this.loginForm(new CLogin());
  show_button_login: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private authService: AuthService,
    private stripeService : StripeService,
    private spinner: NgxSpinnerService,
    private reCaptchaService: ReCaptchaService,
  ) { }
  ngOnInit(): void {}
  /* create login form */
  loginForm(data: CLogin) {
    return this.formBuilder.group({
      username: [
        data.email,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(patternEmail),
        ],
      ],
      password: [
        '',
        [Validators.required, Validators.pattern(patternPassword)],
      ],
    });
  }

  login() {
 this.spinner.show();
 this.reCaptchaService.executeAction('login').then(token => {
    this.invalidCredentials = '';
    this.noUserAccount = '';
    this.validEmaill = '';
    if (this.generateLoginForm.valid) {
      this.loadSpinner = true;

      const body = {
        ...this.generateLoginForm.value,
        recaptchaToken: token
      };

      this.messagecompany = true;
      this.authService
        .login(body)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res: any) => {
              this.toastrService.success(welcomeMessage);
              this.authService.setCookies('token', res.token['access_token']);
              this.authService.setCookies(
                'refresh_token',
                res.token['refresh_token']
              );
              this.localStorageService.saveData('id', res.data.id);

              this.localStorageService.saveData(
                'userConnected', res.data.company.type
              );
              this.localStorageService.saveData(
                'clientConnected',
                res.data.company.id
              );
              this.localStorageService.saveData(
                'clientConnectedName',
                res.data.company.name
              );

              this.localStorageService.saveData('roleUseresn', res.data.role_user_id);
              this.localStorageService.saveData('roleUserclient', res.data.role_user_id);

              this.localStorageService.saveData('roleUseresnnonabonne', res.data.role_user_id);
              this.localStorageService.saveData(
                'UserInfo',
                JSON.stringify(res.data)
              );
               this.stripeService.getActiveSubscriptionPlan().subscribe(subscription => {
                  const subscriptionData = subscription?.data ? subscription.data : null
                  this.localStorageService.saveData('subscription', JSON.stringify(subscriptionData));                  
                  if (res.data.company?.type == 2) {
                    const url = '/accueil';
                    window.location.href = url;
                  }
                  else{
                    const url = '/dashbord';
                    window.location.href = url;
                  } 
                     
                      this.loadSpinner = false;
          })
              this.localStorageService.saveData('clientConnected',  res.data.company.id);
              this.localStorageService.saveData('typeintervenant',  res.data.company.type);

             
          this.spinner.hide();
          },
          error: (err: any) => {
            this.loadSpinner = false;

            this.spinner.hide();
            if (err?.error) {
              this.spinner.hide()
              switch (err?.error.status) {
                case 406:
                  this.toastrService.error(notVerifiedEmail);
                  this.show_button_login = false;
                  this.show_button_resend = true;

                  break;
                case 404:
                  this.noUserAccount = noAccountMail;
                  this.toastrService.error('Pas de compte associé à cette adresse e-mail.');
                  break;
                case 400:
                  if( err?.error.message === 'This user has 5 sessions open') {
                    this.toastrService.error(loginExceedsSessionsNumber);
                  } else{
                    this.invalidCredentials = invalidMailPassword;
                    this.toastrService.error(invalidMailPassword);
                  }
                  break;
                default:
                  this.toastrService.error(serverError);
                   this.toastrService.error('Adresse e-mail ou mot de passe invalide.');
                  break;
              }
            }
          },
        });
    }
    }).catch(err => {
      this.spinner.hide();
      this.toastrService.error('reCAPTCHA verification failed. Please try again.');
    });
  }

  /* sending mail to verif code */

  resendCodeVerification() {
    this.reCaptchaService.executeAction('resendCodeVerification').then(token => {
    const data = { email: this.generateLoginForm.value.username, recaptchaToken: token };

    this.authService
      .resendCodeVerification(data)
      .pipe()
      .subscribe({
        next: (data) => {
          this.toastrService.success(codeSended);
          this.router.navigate([
            '/auth/code-verification',
            { email: this.generateLoginForm.value.username },
          ]);
        },
        error: (err) => {
          if (err?.error) {
            this.toastrService.error(err);
          }
        },
      });
      }).catch(err => {
      this.spinner.hide();
      this.toastrService.error('reCAPTCHA verification failed. Please try again.');
    });
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
